import CommonPage from '@/components/TkCommonPage/index.vue'
import CommonPagination from "@/components/TkCommonPage/components/tableComp/CommonPagination.vue"

import FormSelectItem from "@/components/TkCommonPage/components/tableComp/formItems/FormSelectItem.vue"
import FormGroupSearchItem from "@/components/TkCommonPage/components/tableComp/formItems/FormGroupSearchItem.vue"
import FormDateItem from "@/components/TkCommonPage/components/tableComp/formItems/FormDateItem.vue"
import FormTimeItem from "@/components/TkCommonPage/components/tableComp/formItems/FormTimeItem.vue"
import FormDatetimeItem from "@/components/TkCommonPage/components/tableComp/formItems/FormDatetimeItem.vue"
import FormTextItem from "@/components/TkCommonPage/components/tableComp/formItems/FormTextItem.vue"
import FormPopupItem from "@/components/TkCommonPage/components/tableComp/formItems/FormPopupItem.vue"
import FormGroupSelectItem from "@/components/TkCommonPage/components/tableComp/formItems/FormGroupSelectItem.vue"
import FormImageItem from "@/components/TkCommonPage/components/tableComp/formItems/FormImageItem.vue"
import FormNumberItem from "@/components/TkCommonPage/components/tableComp/formItems/FormNumberItem.vue"
import FormVideoItem from "@/components/TkCommonPage/components/tableComp/formItems/FormVideoItem.vue"
import FormEditorItem from "@/components/TkCommonPage/components/tableComp/formItems/FormEditorItem.vue"
import FormFileItem from "@/components/TkCommonPage/components/tableComp/formItems/FormFileItem.vue"

import TableImageItem from "@/components/TkCommonPage/components/tableComp/tableItems/TableImageItem.vue"
import TableNumberItem from "@/components/TkCommonPage/components/tableComp/tableItems/TableNumberItem.vue"
import TableDatetimeItem from "@/components/TkCommonPage/components/tableComp/tableItems/TableDatetimeItem.vue"
import TableEditorItem from "@/components/TkCommonPage/components/tableComp/tableItems/TableEditorItem.vue"
import TableGroupItem from "@/components/TkCommonPage/components/tableComp/tableItems/TableGroupItem.vue"
import TableSelectItem from "@/components/TkCommonPage/components/tableComp/tableItems/TableSelectItem.vue"
import TableTextItem from "@/components/TkCommonPage/components/tableComp/tableItems/TableTextItem.vue"
import TableTimeItem from "@/components/TkCommonPage/components/tableComp/tableItems/TableTimeItem.vue"
import TableVideoItem from "@/components/TkCommonPage/components/tableComp/tableItems/TableVideoItem.vue"
import TablePopupItem from "@/components/TkCommonPage/components/tableComp/tableItems/TablePopupItem.vue"
import TablePopup2Item from "@/components/TkCommonPage/components/tableComp/tableItems/TablePopup2Item.vue"
import TablePopupDtableItem from "@/components/TkCommonPage/components/tableComp/tableItems/TablePopupDtableItem.vue"
import TableFileItem from "@/components/TkCommonPage/components/tableComp/tableItems/TableFileItem.vue"
import FormLabelItem from "@/components/TkCommonPage/components/tableComp/formItems/FormLabelItem.vue"

export default {
  components: {
    CommonPage,
    CommonPagination,
    FormSelectItem,
    FormGroupSearchItem,
    FormDateItem,
    FormTimeItem,
    FormDatetimeItem,
    FormTextItem,
    TableImageItem,
    TableNumberItem,
    TableDatetimeItem,
    TableEditorItem,
    TableGroupItem,
    TableSelectItem,
    TableTextItem,
    TableTimeItem,
    TableVideoItem,
    FormPopupItem,
    FormGroupSelectItem,
    FormImageItem,
    FormNumberItem,
    FormVideoItem,
    TablePopupItem,
    TablePopup2Item,
    TablePopupDtableItem,
    FormEditorItem,
    FormFileItem,
    TableFileItem,
    FormLabelItem
  }
}
